import { ReactNode } from "react";

import { cn } from "@/utils/cn";

interface Props {
  index: number;
  tag?: string;
  heading: string;
  dek?: string;
  meta?: ReactNode;
  onClick?: () => void;
  className?: string;
  children?: ReactNode;
}

export function NumberedCard({
  index,
  tag,
  heading,
  dek,
  meta,
  onClick,
  className,
  children,
}: Props) {
  const Wrapper = onClick ? "button" : "div";
  return (
    <Wrapper
      onClick={onClick}
      className={cn(
        "editorial-card group flex w-full flex-col gap-3 text-left",
        onClick && "cursor-pointer hover:border-oxblood-300",
        className,
      )}
    >
      <div className="flex items-baseline gap-4">
        <span className="number-anchor">{index.toString().padStart(2, "0")}</span>
        <div className="flex-1">
          {tag ? <span className="pill-accent">{tag}</span> : null}
          <h3 className="mt-2 font-serif text-headline text-espresso-700 group-hover:text-oxblood-500">
            {heading}
          </h3>
          {dek ? <p className="mt-2 font-serif text-dek text-warmgray-500">{dek}</p> : null}
        </div>
      </div>
      {children}
      {meta ? <div className="mt-3 border-t border-ruleline pt-3 text-xs text-warmgray-400">{meta}</div> : null}
    </Wrapper>
  );
}
